module.exports = __webpack_public_path__ + "static/media/cart.3ab4f5c5.webp";